import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        margin : "1%"
    },
  }));

function AutoFormViewLayout ( props ) {

    const { children, ...others } = props;

    const classes = useStyles();

    return (

        <div className={classes.root} {...others} >
            { children }
        </div>

    );
}

export default AutoFormViewLayout;

  